module.exports = __webpack_public_path__ + "static/media/options-icon.17282a3c.svg";